import styled from 'styled-components/native';

export default styled.Text`
  font-family: BasierCircle-Medium;
  margin-right: 6px;
`;
